import { apiClient } from './client';
import { DhPlay } from '@raketta/shared';

export interface DogHouseSpinResult {
  betId: number;
  play: DhPlay;
  totalWin: string;
  amount: string;
  newBalance: string;
  nonce: number;
  serverSeedHash: string;
  clientSeed: string;
  createdAt: string;
}

export const dogHouseApi = {
  spin: (amount: string, buyBonus = false) =>
    apiClient.post<DogHouseSpinResult>('/slots/doghouse/spin', { amount, buyBonus }).then((r) => r.data),
};
